module.exports = {
  path: '/table_basic',
  name: 'table',
  meta: { title: '联赛管理', icon: 'el-icon-upload' },
  component: () => import('../views/table/table.vue') //子分类挂载过度,
}
